import React, {useState} from 'react';
import PropTypes from 'prop-types';
import useAfterUpdateEffect from "../../../../../utils/useAfterUpdateEffect";
import apiUser from "../../../../../apiUser";
import LoadingSpinner from "../../../../LoadingSpinner/LoadingSpinner";
import {Alert, ListGroup, ListGroupItem} from "reactstrap";
import useDidMountEffect from "../../../../../utils/useDidMountEffect";
import Icon from "../../../../../componentsReusable/Icon";
import {useTranslation} from "react-i18next";
import {useTecRmi} from "../../../../../contexts/TecRmiContext";

const Step3 = props => {
  const { getApiPrimaryParams } = useTecRmi()
  const { t } = useTranslation('tec_rmi');
  const [loading, setLoading] = useState(false)
  const [serviceProposal, setServiceProposal] = useState(null)

  useDidMountEffect(() => {
    fetchData()
  })

  useAfterUpdateEffect(() => {
    fetchData()
  }, [props.cooGroupId])

  useAfterUpdateEffect(() => {
    if(props.serviceProposalOption){
      switch (props.serviceProposalOption) {
        case 'before': {
          props.onChooseServiceProposal(serviceProposal.LastServiceBeforKmMonth, 'before')
          break;
        }
        case 'after': {
          props.onChooseServiceProposal(serviceProposal.NextServiceAfterKmMonth, 'after')
          break;
        }
      }
    }
  }, [serviceProposal])

  const fetchData = () => {
    setServiceProposal(null)
    if(!props.cooGroupId){
      return
    }
    setLoading(true)

    apiUser.tecRmi.maintenance.serviceProposal({
      ...getApiPrimaryParams(),
      kindOfVehicleTreeId: 3,
      mdBodyQualColId: props.bodyForMaintenances,
      cooGroupId: props.cooGroupId,
      currentMileage: props.mileage,
      initalRegistrationDate: props.initalRegistrationDate,
    })
      .then(res => setServiceProposal(res.data))
      .finally(() => setLoading(false))
  }

  if(loading){
    return <LoadingSpinner />
  }

  return (
    <div>
      {!serviceProposal && <Alert color={'warning'}>{t('service_proposal.stage_1.step3.title')}</Alert>}
      {serviceProposal && <React.Fragment>
        <ListGroup>
          <ListGroupItem color={'info'} className="cursor-pointer d-flex flex-row flex-nowrap align-items-center py-1" onClick={() => props.onChooseServiceProposal(serviceProposal.LastServiceBeforKmMonth, 'before')}>
            <Icon tooltip={t('service_proposal.stage_1.step3.click_to_choose')} className="far fa-circle mr-2 py-1 my-1" style={{ fontSize: '1.2rem' }} />
            <span>{t('service_proposal.stage_1.step3.last_service')}</span>
          </ListGroupItem>
          {serviceProposal.LastServiceBeforKmMonth.map((service, key) => <ListGroupItem key={key.toString()}>
            <span>{service.ItemMpText} - {service.KorText}{service.QualColId > 0 && <span>&nbsp;{service.QualColText}</span>}</span>
          </ListGroupItem>)}
        </ListGroup>
        <ListGroup className="mt-2">
          <ListGroupItem color={'info'} className="cursor-pointer d-flex flex-row flex-nowrap align-items-center py-1" onClick={() => props.onChooseServiceProposal(serviceProposal.NextServiceAfterKmMonth, 'after')}>
            <Icon tooltip={t('service_proposal.stage_1.step3.click_to_choose')} className="far fa-circle mr-2 py-1 my-1" style={{ fontSize: '1.2rem' }} />
            <span>{t('service_proposal.stage_1.step3.next_service')}</span>
          </ListGroupItem>
          {serviceProposal.NextServiceAfterKmMonth.map((service, key) => <ListGroupItem key={key.toString()}>
            <span>{service.ItemMpText} - {service.KorText}{service.QualColId > 0 && <span>&nbsp;{service.QualColText}</span>}</span>
          </ListGroupItem>)}
        </ListGroup>
      </React.Fragment>}
    </div>
  );
};

Step3.propTypes = {
  onChooseServiceProposal: PropTypes.func.isRequired,
  bodyForMaintenances: PropTypes.number,
  cooGroupId: PropTypes.number,
  mileage: PropTypes.number,
  initalRegistrationDate: PropTypes.string,
  serviceProposalOption: PropTypes.string,
};

export default Step3;